<script>
    import NavRoutLink from "../atoms/NavRoutLink.svelte";

    //local
    let pos = 5;

    let url = window.location.href;
    let localisation = url.split('/')[pos] === "" ? "Accueil" : url.split('/')[pos];
</script>

<nav>
    <ul>
        <NavRoutLink route="" text="Accueil" bind:localisation={localisation} />
        <NavRoutLink route="presentation" text="Presentation" bind:localisation={localisation} />
        <NavRoutLink route="portefolio" text="Portefolio" bind:localisation={localisation} />
        <NavRoutLink route="contact" text="Contact" bind:localisation={localisation} />
    </ul>
</nav>

<style>
    ul{
        display: flex;
        list-style-type: none;
        justify-content: space-around;
        padding: 10px;
        margin: 0px;
    }

    nav{
        border-width: 1px;
        border-color: rgba(157,138,186);
        border-bottom-style: solid;
        position: fixed;
        width: 100%;
        background-color: white;
        top: 0px;
        z-index: 1;
    }
</style>